import React, {Component} from 'react'
import ModalApp from '../SharedComponents/Modal'
import EditFileBody from './EditFileBody'
import {connect} from 'react-redux'
import { Icon } from 'semantic-ui-react'

class EditModal extends Component {
    render() {
        const header = this.props.editID === "all" ? "Read All Files With These Options" : "Read File With These Options";

        return (
            <ModalApp name="editModal"
                      header={<h2><Icon name="edit outline" /> {header}</h2>}
                      size="small"
                      body={<EditFileBody/>}
            />
        )
    }
}

const mapStateToProps = (state) => ({
    editID: state.mainState.editID
})

const mapActionsToProps = {}

export default connect(mapStateToProps, mapActionsToProps)(EditModal)